<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已过账</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">收款单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
			    <Col span="8">单据编号：{{documentItem.code}}</Col>
			    <Col span="8">业务日期：{{documentItem.businessDate}}</Col>
			    <Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
			    <Col span="8">付款人：{{documentItem.payer}}</Col>
			    <Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					单据信息
				</div>
			</div>
			<Table :columns="tableColumns" :data="documentItem.receiptDetailLists"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	export default {
		name: 'receiptplanlistdetail',
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
                    id: 0,
                    code: '',
                    businessDate: '',
                    amount: 0,
                    discount: 100,
                    receiptDetailLists: [],
                    payer: '',
                    userId: '',
                    userName: '',
                    creator: parseInt(localStorage.getItem("userId")),
                    note: '',
                    payWay: '',
                    checkState: 1,//未过账
                    fileList:[]
				},
				tableColumns: [
                    {
                        title: '单据类型',
                        key: 'type',
                        width: 150
                    },
                    {
                        title: '单据编号',
                        key: 'listCode',
                        render: (h,params) => {
							return h('a', {
								class:'jxyd-a',
							    on: {
							        click: (val) => {
										if (params.row.type == '销售单') {
											this.$router.push({
												path: 'saleslistdetail',
												query: {
													salesListCode: params.row.listCode
												}
											});
										} else if (params.row.type == '采购退货单') {
											this.$router.push({
												path: 'returnlistdetail',
												query: {
													returnListCode: params.row.listCode
												}
											});
										} else if (params.row.type == '其他收款单') {
											this.$router.push({
												path: 'otherreceiptlistdetail',
												query: {
													otherReceipeListCode: params.row.listCode
												}
											});
										}
							        }
							    }
							}, params.row.listCode);
                        }
                    },
                    {
                        title: '单据日期',
                        key: 'businessDate',
                    },
                    {
                        title: '单据金额',
                        key: 'listAmount',
                    },
                    {
                        title: '已核销金额',
                        key: 'amountPaid',
                    },
                    {
                        title: '未核销金额',
                        key: 'amountUnpaid',
                    }],
				receiptDetail:[]
			}
		},

		methods: {
			getReceiptList(receiptListId) {
				let self = this;
				request.get('/api/ReceiptList/GetReceiptList', {
					params: {
						id: receiptListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
			getReceiptListByCode(receiptListCode) {
				let self = this;
				request.get('/api/ReceiptList/GetReceiptListByCode', {
					params: {
						code: receiptListCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			}
		},
		watch: {
			'$route.query.receiptListId':{
				immediate: true,
				handler(param) {
					if(param){
						this.getReceiptList(param);
					}
				}
			},
			'$route.query.receiptListCode':{
				immediate: true,
				handler(param) {
					if(param){
						this.getReceiptListByCode(param);
					}
				}
			}
		},
		created: function() {
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}
	
	.list-base{
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}
	
	.list-base-left{
		float: left;
		display: flex;
		color: #000;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 100%;           /* 父元素需要固定高度或其他百分比高度 */
	}
	
	.list-base-left-span{
		font-size: 18px;
	}
	
	.list-base-right{
		display: flex;
		float: right;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 36px;     
	}
	
	.list-base-right-span{
		margin-left: 10px;
	}
	
	.span-back-color{
		color: #000;
	}
	
	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}
	
	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}
	
	.list-module{
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}
	
	.div-content-row div{
		padding: 15px;
	}
	
	.div-content-row-center div{
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}
	
	.amount-color{
		color: rgb(255, 106, 127);
	}
	
	.div-content-detail{
		margin: 15px;
		background-color:#f8f8f9;
		padding: 20px;
	}
	
	.div-content-detail-title{
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}
	.div-content-detail-list{
		margin-top: 10px;
	}
	.div-content-detail-list-title{
		text-indent: 0.5em;
	}
	
	.div-content-detail-list-content{
		overflow: hidden;
	}
	
	.div-content-detail-list-content-item{
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}
	
	.extraCostShowTable {
	    margin-top: 10px;
		color: #000;
	}
	
	    .extraCostShowTable td {
	        padding: 5px;
	    }
	
</style>